import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as n } from "../../../../IconBase-CxZyIWw2.js";
const a = i((e, l) => /* @__PURE__ */ o.jsx(
  n,
  {
    ref: l,
    ...e,
    image: (r) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...r,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zm-19.603-1.506h3.216v3.52h1.84v-8.401h-1.84v3.334h-3.216v-3.334h-1.84V20h1.84zm6.2 5.724q.432.135.995.135.985 0 1.623-.527.639-.521 1.032-1.659l2.18-6.334h-1.84l-1.202 4.16-1.336-4.16h-1.91l2.332 6.211q-.193.445-.463.633-.264.188-.668.188-.415 0-.744-.13z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
a.displayName = "HydroquinoneIcon";
export {
  a as HydroquinoneIcon,
  a as default
};
//# sourceMappingURL=index.js.map
